import React from "react";
import RequestDetailModal from "./RequestDetailModal";

const EneoModal = (props) => <RequestDetailModal {...props} />;

export default EneoModal;
